import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import "@miljodirektoratet/md-css";
import TilesComponent from './components/tiles.jsx';
import { MdPinIcon64 } from '@miljodirektoratet/md-react';
import logo from './assets/logo-primary.svg'; // Import your logo image
import PageEsri from './pages/esri.jsx';
import PageOpenLayers from './pages/openlayers.jsx';
import PageLeaflet from './pages/leaflet.jsx';

function App() {
  return (
    <Router>
      <div id="app-container">
        <header>
          <img src={logo} alt="Logo" className="logo" /> {/* Add the logo image */}
          <div className="header-title">
            <h1> Kart eksempler i JavaScript</h1>
          </div>
        </header>
        <main>
          <Routes>
            <Route path="/" element={
              <div className="tiles-container">
                <TilesComponent 
                  heading="ArcGIS" 
                  icon={<MdPinIcon64 height={64} width={64} />} 
                  href="/esri" /* Specify the target URL */
                  mode="small" /* Change the size of the tile */
                />
                <TilesComponent 
                  heading="OpenLayers" 
                  icon={<MdPinIcon64 height={64} width={64} />} 
                  href="/openlayers" 
                  mode="small" 
                />
                <TilesComponent 
                  heading="Leaflet" 
                  icon={<MdPinIcon64 height={64} width={64} />} 
                  href="/leaflet" 
                  mode="small" 
                />
              </div>
            } />
            <Route path="/esri" element={<PageEsri />} />
            <Route path="/openlayers" element={<PageOpenLayers />} />
            <Route path="/leaflet" element={<PageLeaflet />} />
          </Routes>
        </main>
        <footer>
          <p>&copy; 2025 Miljødirektoratet</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;